exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".content[data-v-3be017c7]{font-size:.9rem}.row[data-v-3be017c7]{border-bottom:1px solid #ddd}", ""]);
